import * as TempInterface from "./interface";
export * from "./interface";
export const tempTemplate: TempInterface.TemplateTEMP = () => ({
  AvailableOffers: [],
  BookingPaymentAddresses: [],
  BookingPaymentAddressesLength: 0,
  BookingPaymentContacts: [],
  CallFetched: false,
  CallsHistory: [],
  CardCVC: "",
  CardExpiry: "",
  AvailablePromoCodes: [],
  CardNumber: "",
  AddressAccountsListAllowedToMerge: [
    "PropertyAddress",
    "CarePlanCustomerAddress",
    "CarePlanPlanDetailsAddress",
    "CarePlanBillingAddress",
    "BookingPaymentAddress"
  ],
  ContactAccountsListAllowedToMerge: [
    "PropertyContact",
    "LandlordContact",
    "CarePlanCustomerContact",
    "CarePlanBillingContact",
    "BookingPaymentContact"
  ],
  PropertyContactContacts: [],
  BookingPaymentAddressActiveSearch: false,
  BookingPaymentAddressAddresses: [],
  BookingPaymentAddressAddressesLength: 0,
  BookingPaymentContactContacts: [],
  CarePlanAddressAddressesLength: 0,
  LandlordAddressActiveSearch: false,
  LandlordAddressAddresses: [],
  LandlordAddressAddressesLength: 0,
  LandlordContactContacts: [],
  ProblemAddressActiveSearch: false,
  ProblemAddressAreaCode: "",
  ProblemAddressCoverage: false,
  ProblemAddressNewAreaCode: "",
  ProblemAddressPostcodeValid: false,
  ProblemAddressSearchDone: false,
  ProblemContactContacts: [],
  PropertyAddressActiveSearch: false,
  PropertyAddressAddresses: [],
  PropertyAddressAddressesLength: 0,
  PropertyAddressSelectedAddress: null,
  PropertyAddressValidPostcode: null,
  RelatedAddressAddressesLength: 0,
  RelatedContactContacts: [],
  name: undefined,
  RelatedAddressActiveSearch: false,
  LandlordAddressSelectedAddress: null,
  CarePlanBillingAddressActiveSearch: false,
  CarePlanBillingAddressAddresses: [],
  CarePlanBillingAddressAddressesLength: 0,
  CarePlanBillingContactContacts: [],
  CarePlanCustomerAddressActiveSearch: false,
  CarePlanCustomerAddressAddresses: [],
  CarePlanCustomerAddressAddressesLength: 0,
  CarePlanCustomerContactContacts: [],
  CarePlanPaymentAddressActiveSearch: undefined,
  CarePlanPaymentAddressAddressesLength: 0,
  CarePlanPaymentContactContacts: [],
  CarePlanPlanDetailsAddressActiveSearch: false,
  CarePlanPlanDetailsAddressAddresses: [],
  CarePlanPlanDetailsAddressAddressesLength: 0,
  CompletedJobs: {},
  CurrentDestNumber: null,
  DestinationNumber: null,
  JobReviews: {},
  LandlordActiveSearch: false,
  LandlordAddresses: undefined,
  LandlordAddressesLength: 0,
  LandlordSelectedAddress: null,
  Last2: [],
  Loading: null,
  PostcodeArea: "",
  PostcodeSector: "",
  ProblemActiveSearch: false,
  ProblemAreaCode: "",
  ProblemNewAreaCode: "",
  ProblemPostcodeValid: false,
  ProblemResponseTimes: [],
  ProblemSearchDone: false,
  PropertyActiveSearch: false,
  PropertyAddressesLength: 0,
  PropertySelectedAddress: null,
  PropertyValidPostcode: null,
  RelatedAddressesLength: 0,
  RequiredOptions: false,
  ServiceAgreementAddressesLength: 0,
});
